module.exports = __webpack_public_path__ + "img/pro.6ed88f15.png";